<div class="blast-card">
  <div id="map" class="blast-map" (click)="navigateToSite()"></div>

  <div class="d-flex align-items-center">
    <i class="fas fa-compress-arrows-alt blast-title fa-lg"></i>
    <h4>{{tir?.nom}}</h4>
  </div>




  <div class="button-group">
    <button class="primary-button" (click)="creerRapport()"><i class="fa-solid fa-file"></i>{{'GLOBAL.CREER_RAPPORT' | translate}}</button>
    <button class="btn btn-outline-primary action-button" (click)="ouvrirModaleModif()"><i class="fa-solid fa-pen"></i>{{'GLOBAL.MODIFIER' |
  translate}}</button>
</div>
<hr class="blast-card-divider"/>

<div class="blasted-toggle">
  <div class="mb-2 mt-2">
    <div class="d-flex align-items-center justify-content-start">
      <div class="switch2">
        <input id="isBlasted" type="checkbox" [checked]="isBlasted" (click)="handleBlastedClick($event)"/>
        <label for="isBlasted"></label>
      </div>
      <b>
        {{'GLOBAL.BLASTED' | translate}}
      </b>
    </div>
  </div>
</div>

<div class="blast-details">
  @if (isBlasted) {
    <div class="row">
      <div class="col-md-6">
        <span class="label-span">{{'TIR.REAL_DATE' | translate}}</span><br>
        {{ tir?.dateTirEffective != null ? (tir.dateTirEffective | date: 'dd/MM/yyyy') : '' }}
      </div>
      <div class="col-md-6">
        <span class="label-span">{{'GLOBAL.TIME' | translate}}</span><br>
        {{ tir?.dateTirEffective != null ? (tir.dateTirEffective | date: timeFormat) : '' }}
      </div>
    </div>
  }
  <div class="row">
    <div class="col-md-6">
      <span class="label-span">{{'TIR.PLAN_DATE' | translate}}</span><br>
      {{ tir?.dateTirPrevisionnelle | date: 'dd/MM/yyyy' }}
    </div>
    <div class="col-md-6">
      <span class="label-span">{{'MODALE_DONNEE_SUIVI.TYPE' | translate}}</span><br>
      {{ tir?.typeTir?.nom }}
    </div>
  </div>
  <div>
    <span class="label-span">{{'GLOBAL.ZONE' | translate}}</span><br>
    {{ tir?.nomZone }}
  </div>
  <div>
    <span class="label-span">{{'GLOBAL.REGION' | translate}}</span><br>
    {{ userService.currentSite()?.region?.nom }}
  </div>
  <div>
    <span class="label-span">{{'GLOBAL.SITE' | translate}}</span><br>
    {{ userService.currentSite()?.nom }}
  </div>
  <div>
    <span class="label-span">{{'GLOBAL.PROJET' | translate}}</span><br>
    {{ tir?.nomProjet }}
  </div>
</div>

</div>
